module.exports = __webpack_public_path__ + "img/ft.4ff3461d.png";